import { Box } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

export const LicenseItemWrapper = styled(Box)`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.sm}px;
`

export const IconWrapper = styled(Box)`
  display: flex;
  width: 48px;
  height: 48px;
  padding: 10px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  aspect-ratio: 1/1;
  border-radius: 12px;
  background: ${theme.colors.devicesRowHoverBg};
`

export const ContentWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 4px;

  .label {
    color: ${theme.colors.textSecondary};
    font-family: Quicksand, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
  }

  .value {
    color: ${theme.colors.foreground};
    font-family: Quicksand, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    display: flex;
    align-items: center;
    gap: 8px;

    span {
      color: ${theme.colors.cardDateText};
    }
  }
`
